import React, { ReactNode } from 'react';

import { IconTypes } from 'components/Icons';
import { DashboardOverviewWrapperCard } from 'containers/Dashboard/utils/DashboardOverviewWrapperCard';

interface Props {
  content: ReactNode;
  rightHeader: ReactNode;
}

export const ReportsDashboardHeader: React.FC<Props> = props => {
  return (
    <DashboardOverviewWrapperCard
      label="Dashboard"
      iconType={IconTypes.MixedChart}
      iconBgColor="primary"
      iconStyles={{ p: 1 }}
      {...props}
    />
  );
};
